module.exports = __webpack_public_path__ + "img/aprovechar-las-oportunidades.4621412.png";